<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="epigraph"><span>I was born not knowing</span></p>
<p class="center"><span>and have only had a little time to change that here and there.</span></p>
<p class="center"><span>—Richard Feynman</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4epigraph.vue?0b3650fc